// Validation for the sales/marketing lead fields on the register page.
// Ported from landing/components/marketing/validation.ts. Covers only the
// lead fields; password/confirm are validated separately in Register.tsx.

import { ContactFormValues } from './fieldMapping';

export interface ValidationErrors {
  name?: string;
  email?: string;
  contactNo?: string;
  whoAreYou?: string;
  individualJobRole?: string;
  schoolName?: string;
  stream?: string;
  yearsOfExperience?: string;
  codingLanguages?: string;
  orgName?: string;
  orgSize?: string;
  orgJobRole?: string;
  orgWebsite?: string;
  password?: string;
  confirm?: string;
}

export function validateContactFields(values: ContactFormValues): ValidationErrors {
  const errors: ValidationErrors = {};

  if (!values.name || values.name.trim().length < 2) {
    errors.name = 'Please enter your full name (minimum 2 characters).';
  }

  // Require a real 2+ letter TLD so the client matches the server's stricter
  // email check (zod .email()). The old regex accepted e.g. "a@b.c", which the
  // server then rejected with a confusing generic error after signup.
  const emailRegex = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;
  if (!values.email) {
    errors.email = 'Email is required.';
  } else if (!emailRegex.test(values.email.trim())) {
    errors.email = 'Please enter a valid email address.';
  }

  const phoneRegex = /^[\s()+-]*([0-9][\s()+-]*){6,15}$/; // 6 to 15 digits
  if (!values.contactNo) {
    errors.contactNo = 'Contact No. is required.';
  } else if (!phoneRegex.test(values.contactNo)) {
    errors.contactNo = 'Please enter a valid contact number (6 to 15 digits).';
  }

  if (!values.whoAreYou) {
    errors.whoAreYou = 'Please select if you are an Individual or an Organization.';
  } else if (values.whoAreYou === 'Individual') {
    if (!values.individualJobRole) {
      errors.individualJobRole = 'Please select a Job Role.';
    }
    if (values.individualJobRole === 'Active Student') {
      if (!values.schoolName || values.schoolName.trim().length < 2) {
        errors.schoolName = 'Your School/College Name is required.';
      }
      if (!values.stream || values.stream.trim().length < 2) {
        errors.stream = 'Your Stream is required.';
      }
    }
    if (values.individualJobRole === 'Developer') {
      if (!values.yearsOfExperience) {
        errors.yearsOfExperience = 'Please select your years of experience.';
      }
      if (!values.codingLanguages) {
        errors.codingLanguages = 'Please select a coding language.';
      }
    }
  } else if (values.whoAreYou === 'Organization') {
    if (!values.orgName || values.orgName.trim().length < 2) {
      errors.orgName = 'Organization Name is required.';
    }
    if (!values.orgSize) {
      errors.orgSize = 'Please select your organization size.';
    }
    if (!values.orgJobRole) {
      errors.orgJobRole = 'Please select a Job Role.';
    }
  }

  return errors;
}
